import styled, { css } from 'styled-components';
import { Flex, Modal } from 'UI';

const reuseGradient = css`
  background: conic-gradient(
    from 166.04deg at 55.94% -29.43%,
    #ea82ac 0deg,
    #071552 60.58deg,
    #3994d7 107.31deg,
    #453a8b 159.23deg,
    #ea82ac 181.73deg,
    #ea82ac 360deg
  );
`;

// Scope the fixed height + overflow-y to `.ant5-modal-body` only (not the whole
// `.ant5-modal-content`), so the antd title (SStickyHeader) stays outside the scrolling
// area and the modal keeps a constant outer height (it is centered by the shared Modal).
export const SModal = styled(Modal)`
  .ant5-modal-body {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 160px);
    overflow-y: auto;
    scrollbar-gutter: stable;
    padding: 0px !important;
  }
  /* Stretch the modal's content wrapper (MarginBox) so the list view can fill the full body height. */
  .ant5-modal-body > * {
    flex: 1 1 auto;
    min-height: 0;
  }
  .ant5-modal-content {
    padding: 0 !important;
  }
  .ant5-modal-header {
    margin-bottom: 0 !important;
  }
  .ant-tabs-nav::before {
    border: 0 !important;
  }
  border-radius: 8px !important;
  max-width: 1300px !important;
`;

export const SReuseAvailabilitiesButton = styled(Flex)`
  width: fit-content;
  min-width: 150px;
  max-width: 250px;
  min-height: 30px;
  border-radius: 8px;
  margin-top: 5px;
  margin-bottom: 10px;
  padding: 0 16px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  ${reuseGradient}
`;

// `Flex` (UI component) only forwards a fixed prop list to the DOM (onClick, data-cy) and
// silently drops anything else (data-testid, aria-*) — plain elements are used below so
// test ids and accessibility attributes actually reach the DOM.
export const SStickyHeader = styled(Flex)`
  padding: 12px 24px;
  border-radius: 8px 8px 0px 0px;
  ${reuseGradient}
`;

export const SStickyIdRefBox = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  z-index: 9;
  padding: 15px;
  margin-bottom: 15px;

  border-radius: 8px 8px 0px 0px;
  box-shadow: 0 4px 10px 0 ${({ theme }) => theme.color.grey75};
`;

// Anchor for the slide-in filter panel; `min-height: 100%` keeps the panel spanning the full
// modal height even when the filtered list shrinks; `overflow: hidden` clips the off-screen panel.
export const SListView = styled.div`
  position: relative;
  min-height: 100%;
  overflow: hidden;
`;

export const SFilterTrigger = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: none;
  border: solid 1px ${({ theme }) => theme.color.grey85};
  border-radius: 8px;
  cursor: pointer;
  margin-bottom: 16px !important;
`;

export const SPartsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 15px;
`;

export const SPaginationFooter = styled.nav`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 20px;
`;

export const SPageButton = styled.button<{ $active?: boolean }>`
  min-width: 32px;
  height: 32px;
  border-radius: 6px;
  border: solid 1px ${({ theme }) => theme.color.grey85};
  background-color: ${({ theme, $active }) => ($active ? theme.color.clear_blue : theme.color.white)};
  color: ${({ theme, $active }) => ($active ? theme.color.white : theme.color.brand_black)};
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.4;
  }
`;

export const SFiltersColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 250px;
  max-width: 100%;
`;

export const SFilterSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SColorRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SColorLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const SColorSwatch = styled.div<{ $color: string }>`
  width: 16px;
  height: 16px;
  flex: 0 0 auto;
  border-radius: 50%;
  background-color: ${({ $color }) => $color};
  border: solid 1px ${({ theme }) => theme.color.grey85};
`;
